import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { faPlay } from '@fortawesome/pro-regular-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

/**
 * Giant 'Press Play' button that should be displayed when we detect that audio playback has been blocked.
 */
@Component({
  selector: 'pv2-modal-play-button',
  templateUrl: 'modal-play-button.component.html',
  styleUrl: 'modal-play-button.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class Pv2ModalPlayButtonComponent {
  @Output() playClicked = new EventEmitter();
  protected readonly faPlay = faPlay;

  protected modalPlayEvent = () => {
    this.playClicked.emit();
  };
}
